/*

Array of object

Top level object can be:
1. Header
2. Group (Group can have navItems as children)
3. navItem

* Supported Options

/--- Header ---/

header

/--- nav Grp ---/

title
icon (if it's on top level)
tag
tagVariant
children

/--- nav Item ---/

icon (if it's on top level)
title-+
route: [route_obj/route_name] (I have to resolve name somehow from the route obj)
tag
tagVariant

*/
import dashboard from "./dashboard";
import accountManagement from "./account-management";
import managefops from "./manage-fop";
import merchant from "./merchant";
import orders from "./orders";
import refund from "./refund";
import reconciliation from "./reconciliation";
import monitoring from "./monitoring";
import reports from "./report";
import commission from "./commission";
import exceptions from "./exceptions";
import transactionStatus from "./transaction-status";

// Array of sections
export default [
  ...dashboard,
  ...accountManagement,
  ...managefops,
  ...merchant,
  ...orders,
  ...refund,
  ...reconciliation,
  ...commission,
  ...exceptions,
  ...reports,
  ...transactionStatus,
  ...monitoring,
];
